import React, { useState } from "react";
import {
  DateField,
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { theme } from "theme";
import styled from "styled-components";
import { ColumnFlex } from "components/UploadEndorsementEdit/styles";

const NewDateField = ({ defaultValue, setDate, error }) => {
  const [dateValue, setDateValue] = useState(defaultValue)
//   const [useError, setError] = useState(false)
  const handleDateChange = (value) => {
    setDateValue(dayjs(value).format('YYYY-MM-DD'))
    setDate(dayjs(value).format('YYYY-MM-DD'))
    // setError(dayjs(value).isValid())
    // console.log(value, dayjs(value).format('YYYY-MM-DD'))
  }
  const renderError = (error, style) => {
    return <Error style={style}>{error}</Error>;
  };
//   console.log(dateValue, "date")
  return (
    <ColumnFlex>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateField
        sx={{
          width: "324px",
          marginTop: "24px",
          "& fieldset": {
            border: "1px solid " + theme.baseBlue,
            borderRadius: "6px",
          },
          "& input": {
            fontSize: "medium !important",
            fontFamily: "Inter",
            padding: "13.5px 14px",
          },
          "& label": {
            fontSize: "14px !important",
            fontFamily: "Inter",
            width: "400px",
          },
          "& .Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: `${theme.baseBlue} !important`,
          },
        }}
        defaultValue={dateValue}
        onChange={handleDateChange}
        format="DD/MM/YYYY"
        disableFuture
      />
    </LocalizationProvider>
    {error &&
    renderError(error,{
        position: "inherit",
        marginTop: "1.2rem",
    })}
    </ColumnFlex>
  );
};
export default NewDateField;

const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 4rem;
  position: absolute;
  z-index: 9;
`;